/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { FileReadOnly } from "./FileReadOnly";
import {
  FileReadOnlyFromJSON,
  FileReadOnlyFromJSONTyped,
  FileReadOnlyToJSON,
  FileReadOnlyToJSONTyped,
} from "./FileReadOnly";
import type { Extent1 } from "./Extent1";
import {
  Extent1FromJSON,
  Extent1FromJSONTyped,
  Extent1ToJSON,
  Extent1ToJSONTyped,
} from "./Extent1";
import type { UnitEnum } from "./UnitEnum";
import {
  UnitEnumFromJSON,
  UnitEnumFromJSONTyped,
  UnitEnumToJSON,
  UnitEnumToJSONTyped,
} from "./UnitEnum";
import type { RevisionRasterTypeEnum } from "./RevisionRasterTypeEnum";
import {
  RevisionRasterTypeEnumFromJSON,
  RevisionRasterTypeEnumFromJSONTyped,
  RevisionRasterTypeEnumToJSON,
  RevisionRasterTypeEnumToJSONTyped,
} from "./RevisionRasterTypeEnum";

/**
 * A type of `ModelSerializer` that uses
 * hyperlinked relationships with compound keys instead
 * of primary key relationships.  Specifically:
 * * A 'url' field is included instead of the 'id' field.
 * * Relationships to other instances are hyperlinks, instead of primary keys.
 * NOTE: this only works with DRF 3.1.0 and above.
 * @export
 * @interface RevisionRaster
 */
export interface RevisionRaster {
  /**
   *
   */
  readonly url?: string;
  /**
   *
   */
  type: RevisionRasterTypeEnum;
  /**
   *
   */
  name: string;
  /**
   *
   */
  readonly file?: FileReadOnly;
  /**
   *
   */
  readonly id?: number;
  /**
   *
   */
  readonly epsgCode?: number | null;
  /**
   *
   */
  extent?: Extent1;
  /**
   *
   */
  readonly geotransform?: Array<number> | null;
  /**
   *
   */
  unit?: UnitEnum;
}

/**
 * Check if a given object implements the RevisionRaster interface.
 */
export function instanceOfRevisionRaster(value: object): value is RevisionRaster {
  if (!("type" in value) || value["type"] === undefined) return false;
  if (!("name" in value) || value["name"] === undefined) return false;
  return true;
}

export function RevisionRasterFromJSON(json: any): RevisionRaster {
  return RevisionRasterFromJSONTyped(json, false);
}

export function RevisionRasterFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): RevisionRaster {
  if (json == null) {
    return json;
  }
  return {
    url: json["url"] == null ? undefined : json["url"],
    type: RevisionRasterTypeEnumFromJSON(json["type"]),
    name: json["name"],
    file: json["file"] == null ? undefined : FileReadOnlyFromJSON(json["file"]),
    id: json["id"] == null ? undefined : json["id"],
    epsgCode:
      json["epsg_code"] === undefined
        ? undefined
        : json["epsg_code"] === null
        ? null
        : json["epsg_code"],
    extent: json["extent"] == null ? undefined : Extent1FromJSON(json["extent"]),
    geotransform:
      json["geotransform"] === undefined
        ? undefined
        : json["geotransform"] === null
        ? null
        : json["geotransform"],
    unit: json["unit"] == null ? undefined : UnitEnumFromJSON(json["unit"]),
  };
}

export function RevisionRasterToJSON(json: any): RevisionRaster {
  return RevisionRasterToJSONTyped(json, false);
}

export function RevisionRasterToJSONTyped(
  value?: Omit<RevisionRaster, "url" | "file" | "id" | "epsgCode" | "geotransform"> | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    type: RevisionRasterTypeEnumToJSON(value["type"]),
    name: value["name"],
    extent: Extent1ToJSON(value["extent"]),
    unit: UnitEnumToJSON(value["unit"]),
  };
}
